import { Store } from '@ngxs/store';
import { ɵNG_COMP_DEF, ɵNG_DIR_DEF, ɵɵdirectiveInject, ChangeDetectorRef, NgModuleRef, NgModule } from '@angular/core';
import { __decorate } from 'tslib';

import * as ɵngcc0 from '@angular/core';
class NgxsSelectSnapshotModuleIsNotImported extends Error {
    constructor() {
        super(`You've forgotten to import "NgxsSelectSnapshotModule"!`);
    }
}
let injector = null;
function assertDefined(actual) {
    if (actual == null) {
        throw new NgxsSelectSnapshotModuleIsNotImported();
    }
}
function setInjector(parentInjector) {
    injector = parentInjector;
}
/**
 * Ensure that we don't keep any references in case of the bootstrapped
 * module is destroyed via `NgModuleRef.destroy()`.
 */
function clearInjector() {
    injector = null;
}
function getStore() {
    assertDefined(injector);
    return injector.get(Store);
}

const DOLLAR_CHAR_CODE = 36;
function removeDollarAtTheEnd(name) {
    const lastCharIndex = name.length - 1;
    const dollarAtTheEnd = name.charCodeAt(lastCharIndex) === DOLLAR_CHAR_CODE;
    return dollarAtTheEnd ? name.slice(0, lastCharIndex) : name;
}
function getPropsArray(selectorOrFeature, paths) {
    if (paths.length) {
        return [selectorOrFeature, ...paths];
    }
    return selectorOrFeature.split('.');
}
function compliantPropGetter(paths) {
    const copyOfPaths = [...paths];
    return obj => copyOfPaths.reduce((acc, part) => acc && acc[part], obj);
}
const META_KEY = 'NGXS_META';

function createSelectorFactory(paths) {
    return (selectorOrFeature) => {
        if (typeof selectorOrFeature === 'string') {
            const propsArray = getPropsArray(selectorOrFeature, paths);
            return compliantPropGetter(propsArray);
        }
        else if (selectorOrFeature[META_KEY] && selectorOrFeature[META_KEY].path) {
            return compliantPropGetter(selectorOrFeature[META_KEY].path.split('.'));
        }
        return selectorOrFeature;
    };
}
function getSelectorFromInstance(instance, selectorFnName, createSelector, selectorOrFeature) {
    return instance[selectorFnName] || (instance[selectorFnName] = createSelector(selectorOrFeature));
}
function defineSelectSnapshotProperties(selectorOrFeature, paths, target, name) {
    const selectorFnName = `__${name}__selector`;
    const createSelector = createSelectorFactory(paths);
    Object.defineProperties(target, {
        [selectorFnName]: {
            writable: true,
            enumerable: false,
            configurable: true,
        },
        [name]: {
            get() {
                const selector = getSelectorFromInstance(this, selectorFnName, createSelector, selectorOrFeature);
                // Don't use the `directiveInject` here as it works ONLY
                // during view creation.
                const store = getStore();
                return store.selectSnapshot(selector);
            },
            enumerable: true,
            configurable: true,
        },
    });
    return {
        selectorFnName,
        createSelector,
        selectorOrFeature: selectorOrFeature || removeDollarAtTheEnd(name),
    };
}

function SelectSnapshot(selectorOrFeature, ...paths) {
    return (type, name) => {
        defineSelectSnapshotProperties(selectorOrFeature, paths, type, name);
    };
}

/**
 * This decorator has to be used only with components since only components
 * can have templates and interpolated properties. The purpose of this decorator
 * is also to make `selectSnapshot` working in OnPush components.
 */
function ViewSelectSnapshot(selectorOrFeature, ...paths) {
    return (target, name) => {
        // Means we're running in AOT mode.
        if (!!getDef(target.constructor)) {
            decorateView(selectorOrFeature, paths, target, name);
        }
        else {
            // This means that application is running in the JIT mode. TypeScript invokes
            // property decorators first before class decorators. That means that the `ɵcmp`
            // property is not available yet
            // NOTE: This is safe! Because that micro task is scheduled before
            // the application initialized.
            // Angular waits for the completion of the `APP_INITIALIZER`
            // promise factories later.
            Promise.resolve().then(() => decorateView(selectorOrFeature, paths, target, name));
        }
    };
}
function decorateView(selectorOrFeature, paths, target, name) {
    const properties = defineSelectSnapshotProperties(selectorOrFeature, paths, target, name);
    const def = getDef(target.constructor);
    const factory = getFactory(target.constructor);
    def.factory = () => {
        const instance = factory();
        const selector = getSelectorFromInstance(instance, properties.selectorFnName, properties.createSelector, properties.selectorOrFeature);
        overrideOnDestroy(def, selector);
        return instance;
    };
}
function getFactory(type) {
    return type.ɵfac;
}
function getDef(type) {
    return type[ɵNG_COMP_DEF] || type[ɵNG_DIR_DEF];
}
function createStoreSubscription(selector) {
    const store = ɵɵdirectiveInject(Store);
    // `<any>` is needed here because `ChangeDetectorRef` is an abstract class,
    // abstract classes cannot be assigned to `Type<T>`.
    const ref = ɵɵdirectiveInject(ChangeDetectorRef);
    return store.select(selector).subscribe(() => ref.markForCheck());
}
function overrideOnDestroy(def, selector) {
    const subscription = createStoreSubscription(selector);
    const onDestroy = def.onDestroy;
    def.onDestroy = function () {
        // Invoke the original `ngOnDestroy` if it exists.
        // tslint:disable-next-line
        onDestroy && onDestroy.call(this);
        subscription.unsubscribe();
    };
}

var NgxsSelectSnapshotModule_1;
let NgxsSelectSnapshotModule = NgxsSelectSnapshotModule_1 = class NgxsSelectSnapshotModule {
    constructor(ngModuleRef) {
        setInjector(ngModuleRef.injector);
        ngModuleRef.onDestroy(clearInjector);
    }
    static forRoot() {
        return {
            ngModule: NgxsSelectSnapshotModule_1,
        };
    }
};
NgxsSelectSnapshotModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxsSelectSnapshotModule });
NgxsSelectSnapshotModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxsSelectSnapshotModule_Factory(t) { return new (t || NgxsSelectSnapshotModule)(ɵngcc0.ɵɵinject(ɵngcc0.NgModuleRef)); } });
NgxsSelectSnapshotModule.ctorParameters = () => [
    { type: NgModuleRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxsSelectSnapshotModule, [{
        type: NgModule
    }], function () { return [{ type: ɵngcc0.NgModuleRef }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxsSelectSnapshotModule, SelectSnapshot, ViewSelectSnapshot };

//# sourceMappingURL=ngxs-labs-select-snapshot.js.map